import React, { useEffect, useState } from 'react';
import { StepContainer, NavigationButtons, FormField, InfoBox } from '../index';
import { useWizard } from '../../wizard';
import { contentApi } from '../../services/contentApi';
import { contentKeys } from '../../constants/contentKeys';
import { normalizePhone } from '../../utils/validation';

const CancelStartStep: React.FC = () => {
  const { selfServiceData, updateSelfServiceData, goNext, goBack, sessionId } = useWizard();
  const [errors, setErrors] = useState<{ ref?: string; phone?: string }>({});
  const [body, setBody] = useState<string[] | null>(null);
  useEffect(() => {
    contentApi.getByKey(contentKeys.afbestil.bk_start).then(c => {
      if (c?.body && c.body.length > 0) {setBody(c.body);}
    });
  }, []);

  const validate = () => {
    const e: { ref?: string; phone?: string } = {};
    if (!selfServiceData.cancelBookingRef?.trim()) {e.ref = 'Angiv bookingreference.';}

    const normalizedPhone = normalizePhone(selfServiceData.cancelPhone || '');
    if (!normalizedPhone) {e.phone = 'Angiv telefonnummer.';}
    else if (!/^\d{8}$/.test(normalizedPhone)) {e.phone = 'Telefon skal være 8 cifre.';}

    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const onNext = async () => {
    if (!validate()) {return;}
    // Lookup booking details to show in confirmation
    try {
      const { selfServiceApi } = await import('../../services/selfServiceApi');
      const result = await selfServiceApi.lookupBooking(selfServiceData.cancelBookingRef || '', selfServiceData.cancelPhone || '', sessionId);
      if (result.ok) {
        updateSelfServiceData('location', result.locationId);
        updateSelfServiceData('locationName', result.locationName);
        updateSelfServiceData('date', result.date);
        updateSelfServiceData('time', result.time);
      }
    } catch { /* ignore mock errors */ }
    goNext();
  };

  return (
    <StepContainer title="Afbestil din tid">
      {body ? (
        <InfoBox type="info">{body.map((p,i) => <p key={i}>{p}</p>)}</InfoBox>
      ) : (
        <p>Indtast din bookingreference og telefonnummer for at afbestille din tid.</p>
      )}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
        <FormField
          name="cancelBookingRef"
          value={selfServiceData.cancelBookingRef || ''}
          placeholder="Bookingreference"
          error={errors.ref}
          onChange={(e) => updateSelfServiceData('cancelBookingRef', e.target.value)}
        />
        <FormField
          type="tel"
          name="cancelPhone"
          value={selfServiceData.cancelPhone || ''}
          placeholder="Telefon (8 cifre)"
          error={errors.phone}
          onChange={(e) => updateSelfServiceData('cancelPhone', normalizePhone(e.target.value))}
          autoComplete="tel"
        />
      </div>
      <NavigationButtons onBack={goBack} onNext={onNext} />
    </StepContainer>
  );
};

export default CancelStartStep;
